import type { ProspectFormLockStatus } from '@common/types/formLocks';
import { useQuery } from '@tanstack/react-query';
import { getProspectFormLockStatus } from '@/services/FormLockService';

export function prospectFormLockQueryKey(prospectId?: string) {
    return ['form-lock', prospectId] as const;
}

export function useProspectFormLockStatus(prospectId?: string, enabled = true) {
    return useQuery<ProspectFormLockStatus>({
        queryKey: prospectFormLockQueryKey(prospectId),
        queryFn: () => getProspectFormLockStatus(prospectId as string),
        enabled: enabled && !!prospectId,
        refetchInterval: 15_000,
    });
}
